module.exports = "pegasus/assets/square-twitter-old.png";